module.exports = __webpack_public_path__ + "images/hikakaku-hakkyoi_177da7e962fb9195a031d619fa3de7a7.png";